import React from 'react';
import { FormattedMessage } from 'react-intl';
import api from '../../../api/CategoriesAudit.api';
import withSelection from './../../../reusable/LightTable/hoc/Selectable';
import LightTable from './../../../reusable/LightTable/VeryLightTable';
import { CATEGORIES_PAGE_SIZE, SORT } from '../../../constants';
import { compose } from 'redux';
import withSearch from '../../../reusable/LightTable/hoc/Searchable';
import withInfiniteScroll from '../../../reusable/LightTable/hoc/Scrollable';
import TableCoreComponent from '../../../reusable/LightTable/TableCoreComponent';
import { BoldedCell } from '../../../reusable/LightTable/Components';
import { sortBy } from 'lodash';

const Table = compose(
    withSelection,
    withSearch,
    withInfiniteScroll
)(LightTable);

export default class EntitiesAuditCategoriesTable extends TableCoreComponent {
    constructor(props) {
        super(props);

        const defaultLoadParams = {
            filters:    {query: ""},
            sorting:    {sortBy: "name", direction: SORT.ASC},
            pagination: {pageNumber: 0, pageSize: CATEGORIES_PAGE_SIZE},
            reset:      false
        };

        this.defaultLoadParams = this.loadParams = defaultLoadParams;
        this.api = api;

    }

    componentDidMount() {
        super.componentDidMount();
    }

    formatItem = (item, searchTerm = "") => {
        return {
            key:    item.id,
            name:   <BoldedCell value={item.name} searchTerm={searchTerm} />,
            object: item
        }
    };

    headerItems = [
        {
            key: "name",
            label: <FormattedMessage id='Category_Manage_UIText_tableHeaderElement.category'/>,
            sortable: true
        }
    ];

    handleSelectionChange(selectedItems) {
        this.setState({ selectedItems });
        this.props.onUpdateSelection(selectedItems.map(item => item.object.id));
    };

    selectAllToggle() {
        if (this.state.selectedItems.length === this.state.totalCount) {
            this.setState({ selectedItems: [] });
            this.props.onUpdateSelection([]);
        } else {
            this.api.get(this.defaultLoadParams.filters, this.defaultLoadParams.sorting, { pageNumber: -1, pageSize: -1 }).then(items => {
                let itemsForSelection = items.body.map(item => this.formatItem(item));
                this.setState({ selectedItems: itemsForSelection});
                this.props.onUpdateSelection(itemsForSelection.map(item => item.object.id));
            })
        }
    }


    render = () =>
        <div className="selectable-table empty-category-table">
            <Table {...this.getTableProps()}
                   selectedItems={sortBy(this.state.selectedItems, item => item.name.props.value.toLowerCase())}/>
        </div>
}


// WEBPACK FOOTER //
// ./src/scripts/pages/AccountUsage/Components/EntitiesAuditCategoriesTable.jsx